import _regeneratorRuntime from "/home/soutaito/projects/cocoo_school_admin/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/soutaito/projects/cocoo_school_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.set.js";
import "core-js/modules/web.dom-exception.constructor.js";
import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/web.dom-exception.to-string-tag.js";
import "core-js/modules/web.structured-clone.js";
import "core-js/modules/es.array.find.js";
import { ref, watch } from "vue";
import moment from "moment";
import { storeToRefs } from "pinia";
import { useGradeClassroomStore } from "@/stores/gradeClassroom";
import { useLoadingStore } from "@/stores/loading";
import { useAbsentAlertStore } from "@/stores/absentAlert";
import MonthlyTableHead from "@/components/attendances/monthly/MonthlyTableHead.vue";
import MonthlySchoolDay from "@/components/attendances/monthly/MonthlySchoolDay.vue";
import MonthDailyEvent from "@/components/attendances/monthly/MonthDailyEvent.vue";
import MonthlyComment from "@/components/attendances/MonthlyComment.vue";
import { useMonthData } from "@/composables/monthData";
import { getData } from "@/services/axios";
export default {
  __name: 'MonthlyTemperatureCalendar',
  props: {
    filter: {
      type: Object,
      required: true
    }
  },
  setup: function setup(__props) {
    var props = __props; // @ts-check

    var _storeToRefs = storeToRefs(useGradeClassroomStore()),
        classrooms = _storeToRefs.classrooms;

    var _storeToRefs2 = storeToRefs(useLoadingStore()),
        isLoading = _storeToRefs2.isLoading;

    var absentAlertStore = useAbsentAlertStore();

    var _useMonthData = useMonthData(props.filter),
        monthData = _useMonthData.monthData,
        days = _useMonthData.days;

    var visibleClassroom = ref([]);
    /** @type Ref<Object<number, MonthData[]>> */

    var classMonthData = ref({});
    var dailyEvents = ref({});
    var students = ref({});

    var setData = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var date, data, classMonthlyTemperature, classroom;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                isLoading.value = true;
                _context.prev = 1;
                date = moment(props.filter.yearMonth);
                _context.next = 5;
                return getData(["events?orderby=updated_at&order=asc&classroom_id=" + props.filter.classroomId + "&year_month=" + props.filter.yearMonth, "temperatures/monthly?year_month=".concat(date.format("YYYY-MM-DD"), "&classroom_id=").concat(props.filter.classroomId, "&group_id=").concat(props.filter.groupId)]);

              case 5:
                data = _context.sent;
                // 表示するクラスを整理する

                /** @type {Object<number, any[]>} */
                classMonthlyTemperature = data[1].items;
                students.value = classMonthlyTemperature;
                visibleClassroom.value = [];
                classMonthData.value = {};
                dailyEvents.value = {};

                if (props.filter.classroomId === 0) {
                  // 全てのクラスを選択したとき
                  classrooms.value.forEach(function (v) {
                    if (classMonthlyTemperature[v.id]) {
                      // 所属する生徒が存在する時
                      visibleClassroom.value.push(v);
                      classMonthData.value[v.id] = structuredClone(monthData.value);
                      dailyEvents.value[v.id] = {};
                    }
                  });
                } else {
                  // 個別のクラスを選択したとき
                  classroom = classrooms.value.find(function (v) {
                    return v.id === parseInt(props.filter.classroomId);
                  });
                  visibleClassroom.value.push(classroom);
                  classMonthData.value[classroom.id] = structuredClone(monthData.value);
                  dailyEvents.value[classroom.id] = {};
                }

                data[0].items.forEach(function (v) {
                  // 月をまたぐ際は今月の範囲内に限定する
                  var from = date.isSame(v.from, "month") ? moment(v.from) : date.clone().startOf("month");
                  var to = date.isSame(v.to, "month") ? moment(v.to) : date.clone().endOf("month");

                  while (from.isSameOrBefore(to, "day")) {
                    v.classroom.forEach(function (w) {
                      if (dailyEvents.value[w.classroom_id]) {
                        var key = from.format("YYYY-MM-DD");

                        if (dailyEvents.value[w.classroom_id][key]) {
                          dailyEvents.value[w.classroom_id][key].push(v);
                        } else {
                          dailyEvents.value[w.classroom_id][key] = [v];
                        }

                        classMonthData.value[w.classroom_id][from.date() - 1].isSchoolDayOff = Boolean(v.is_school_day_off);
                      }
                    });
                    from.add(1, "day");
                  }
                });
                _context.next = 18;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context["catch"](1);
                console.log(_context.t0);

              case 18:
                _context.prev = 18;
                isLoading.value = false;
                return _context.finish(18);

              case 21:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 15, 18, 21]]);
      }));

      return function setData() {
        return _ref.apply(this, arguments);
      };
    }();

    watch(props.filter, function () {
      return setData();
    });
    var showModal = ref(false);
    var selectedStudent = ref({});

    var handleCommentEdit = function handleCommentEdit(v) {
      showModal.value = true;
      selectedStudent.value = v;
    };

    var closeModal = function closeModal() {
      showModal.value = false;
    };

    var getNoticeLevel = function getNoticeLevel(t) {
      if (t !== null && t !== void 0 && t.temperature) {
        if (t.temperature >= 37.5) {
          return "warning";
        } else if (t.temperature >= 37.0) {
          return "notice";
        }
      }

      return "";
    }; // created


    setData();
    return {
      __sfc: true,
      props: props,
      classrooms: classrooms,
      isLoading: isLoading,
      absentAlertStore: absentAlertStore,
      monthData: monthData,
      days: days,
      visibleClassroom: visibleClassroom,
      classMonthData: classMonthData,
      dailyEvents: dailyEvents,
      students: students,
      setData: setData,
      showModal: showModal,
      selectedStudent: selectedStudent,
      handleCommentEdit: handleCommentEdit,
      closeModal: closeModal,
      getNoticeLevel: getNoticeLevel,
      MonthlyTableHead: MonthlyTableHead,
      MonthlySchoolDay: MonthlySchoolDay,
      MonthDailyEvent: MonthDailyEvent,
      MonthlyComment: MonthlyComment
    };
  }
};